{
    "use strict";
  
    const searchSelect = document.getElementById("search-keyword")?.content.cloneNode(true).querySelectorAll("option");
    if(searchSelect){
      const frag = document.createDocumentFragment();
      const parent = document.getElementById("custom_search_options");
      for(item of searchSelect){
        frag.appendChild(item);
      }
      parent?.appendChild(frag);
      if(parent){
        parent.querySelector('option[value=""]').selected = true;
      }
    }
  
    let is_phone = false;
  
        document.getElementById("header-search-custom")?.addEventListener("submit", e => {
          if(is_phone) return;
          const input = document.getElementById("search-custom-data-title");
          if(!input) return;
  
          const searchType = document.getElementById("custom_search_options").value;
          input.value = searchType;
      });
    
      document.body.addEventListener("click", e => {
          const board = document.querySelector("#header-search-custom .custom-floating-board");
          if(!board) return;
          if(!board.contains(e.target)){
              board.classList.remove("active");
          }
      });
  
        const getRelation = async (search) => {
          if(search === ""){
              document.querySelector("#header-search-custom .custom-floating-board")?.classList.remove("active");
              return;
          }
          const query = `query test{
              products(first: 100, query: "title:${search}*"){
                  edges{
                      cursor
                      node{
                          id
                          title
                          handle
                          availableForSale
                          productType
                          metafield(namespace:"custom", key: "title_"){
                            key
                            value
                          }
                          featuredImage {
                              url
                          }
                      }
                  }
              }
          }`;
          const res = await fetch("https://mtg-tomonyan.myshopify.com/api/2024-07/graphql.json", {
              method: 'POST',
              headers: {
                  "Content-Type": "application/graphql",
                  "X-Shopify-Storefront-Access-Token": "0fa8bdfc33a76e278cb6f9f7e85bc497",
              },
              body: query
          });
          const data = await res.json();
          const itemArray = data.data.products.edges;
          const productTypeSet = new Set();
          const metaTitleDic = {};
          const type = document.getElementById("custom_search_options")?.value;
          for(item of itemArray){
            const productType = item.node.productType;
            if(type){
              if(item.node.metafield && item.node.metafield.value === type){
                productTypeSet.add(productType);
                metaTitleDic[`${productType}`] = item.node.metafield.value;
              }
            }else{
              productTypeSet.add(productType);
              metaTitleDic[`${productType}`] = item.node.metafield.value;
            }
          }
          console.log(metaTitleDic);
  
          const board = document.querySelector("#header-search-custom .custom-floating-board");
          if(!board) return;
          board.innerHTML = "";
          if(productTypeSet.size <= 0){
              board.classList.remove("active");
              return;
          }
          const ul = document.createElement("ul");
          for(item of productTypeSet){
              const li = document.createElement("li");
              li.textContent = item;
              li.dataset.text = item;
              if(item in metaTitleDic){
                li.dataset.title = metaTitleDic[item];
              }
              li.addEventListener("click", e => {
                // location.href = `/search?filter.p.m.custom.title_=${e.currentTarget.dataset.title}&filter.p.product_type=${e.currentTarget.dataset.text}&q=title:*`;
                  location.href = `/search?filter.p.m.custom.title_=${e.currentTarget.dataset.title}&filter.p.product_type=${e.currentTarget.dataset.text}&q=${search}`;
              });
              ul.appendChild(li);
          }
          board.appendChild(ul);
          board.classList.add("active");
      };
  
      const fetchData = e => {
          if(is_phone) return;
          const is_title = document.getElementById("custom_search_options");
          const search = document.querySelector("#header-search-custom input[type=search]").value;
  
          getRelation(search);
      }
      const debouncedFetchData = debounce(fetchData, 1000);
  
      document.querySelector("#header-search-custom input[type=search]")?.addEventListener("input", debouncedFetchData);
  
      function debounce(func, delay) {
          let timeoutId;
          return function(...args) {
              clearTimeout(timeoutId);
              timeoutId = setTimeout(() => {
                  func.apply(this, args);
              }, delay);
          };
      }
  
      window.matchMedia("(max-width: 767px)").addEventListener("change", e => {
          if(e.matches){
              is_phone = true;
          }else{
              is_phone = false;
          }
      });
  }